module.exports = __webpack_public_path__ + "img/close.8a0894df.png";